import { baseApi } from '@/store/api/base.api';
import { FeedbackResponse } from '@/types/feedbacks';
import { getQueryString } from '@/utils';

export const feedbackApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getFeedbacks: builder.query<
			FeedbackResponse,
			{ page: number; pageSize: number }
		>({
			query: (query) => ({
				url:
					`/feedbacks?` +
					getQueryString({
						pagination: {
							pageSize: query.pageSize,
							page: query.page,
						},
						populate: ['avatar', 'images'],
					}),
				method: 'GET',
			}),
		}),

		getFeedbackBySlug: builder.query<any, { slug: string; query: string }>({
			query: ({ slug, query }) => ({
				url: `/feedbacks/${slug}?${query}`,
				method: 'GET',
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useGetFeedbacksQuery, useGetFeedbackBySlugQuery } = feedbackApi;
